import { IconButton, Stack, useTheme } from "@mui/material";
import { ArrowLeftIcon } from "lucide-react";
import type { FC } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { MyPlannTopBarRedesign } from "web_myplann/Shared/Components/Redesign/MyPlannTopBarRedesign";

const R = Resources.Portfolio.List.Redesign.Documents;

type Props = {
	folder: string;
	documentsCount: number;
	onBack: () => void;
};

export const FolderDetailTopBar: FC<Props> = ({
	folder,
	documentsCount,
	onBack,
}) => {
	const { palette, iconSize } = useTheme();
	const { t } = useResource();

	const subtitle =
		documentsCount > 0
			? t(R.documentsCount, { count: documentsCount })
			: undefined;

	return (
		<Stack width="100%" bgcolor={palette.background.paper}>
			<MyPlannTopBarRedesign
				title={folder}
				subtitle={subtitle}
				startComponent={
					<IconButton onClick={onBack}>
						<ArrowLeftIcon size={iconSize.md} color={palette.grey[900]} />
					</IconButton>
				}
			/>
		</Stack>
	);
};
